import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { pageUrl } from '@/constants/url'

const ServiceCalendarV2 = lazy(() => import('./pages/calendarV2'))
export const calendarRoutes = () => {
  return (
    <>
      <Route path={pageUrl.calendar} element={<ServiceCalendarV2 />} />
    </>
  )
}
